var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"qr-img",attrs:{"src":_vm.QRUrl,"alt":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }